import { rem } from 'polished'
import styled from 'styled-components'
import { tierDarkBackgroundStyle } from 'styles/utils/tierStyles'

/** Circular icon container with tier-based dark background colour. */
export const BenefitIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem(24)};
  height: ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.default.two};
  flex-shrink: 0;
  ${tierDarkBackgroundStyle}
`

/** Countdown/status chip (e.g. "3 months and 9 days left", "In progress"). */
export const CountdownChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: ${rem(24)};
  padding: 0 ${rem(8)};
  background-color: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
  color: white;
  border-radius: ${props => props.theme.borderRadius.S};
  font-size: ${rem(12)};
  font-weight: 500;
  white-space: nowrap;
`

/** Step indicator layout — vertical column with circle + optional connecting line. */
export const StepIndicatorColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
`

/** Circle indicator for a step. Pass `eligible` for completed state. */
export const StepCircle = styled.div<{ eligible?: boolean }>`
  width: ${rem(16)};
  height: ${rem(16)};
  border: 2px solid ${props => props.eligible
    ? props.theme.palette.messaging.success.normalBackground
    : props.theme.palette.neutral.default.four};
  border-radius: ${props => props.theme.borderRadius.round};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.eligible ? props.theme.palette.messaging.success.normalBackground : 'transparent'};
`

/** Vertical connecting line between step circles. */
export const StepLine = styled.div`
  width: ${rem(2)};
  flex: 1;
  background-color: ${props => props.theme.palette.neutral.default.four};
`

/** Step content container (text next to the indicator). */
export const StepContent = styled.div`
  flex: 1;
  padding-bottom: ${rem(12)};
`

/** Step row — holds indicator column + content side by side. */
export const StepItem = styled.div`
  display: flex;
  gap: ${rem(12)};
`

/** Bulleted list for photo hints (used in verification section and modal). */
export const PhotoHintsList = styled.ul`
  list-style: disc;
  padding-left: ${rem(18)};
  margin: 0;

  li {
    font-size: ${rem(14)};
    line-height: ${rem(20)};
  }
`
